/**
 * @param screenRedirectUrl A string in the form of `z={zoneId}`
 * @example "z=44" => 44
 */
export default function parseZoneIdFromScreenRedirectUrl(screenRedirectUrl?: string | null): number {
  if (!screenRedirectUrl) {
    return -1;
  }

  const match = screenRedirectUrl
    .trim()
    .toLowerCase()
    .match(/^z=(\d+)$/);

  if (match) {
    return parseInt(match[1], 10);
  }

  return -1;
}
